import React, { Component } from 'react';
import './ModalExportLots.scss';
import { connect } from 'react-redux';
import { logoutAction } from '../../redux/actions/UserActions';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Button } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customersListAutocomplete } from '../../services/UserServices';
import { Constants } from '../../Constants';

export const statusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: Constants.STATUS_INITIAL, label: 'Pendiente' },
    { value: Constants.STATUS_PENDING, label: 'Subastado' },
    { value: Constants.STATUS_IN_PROGRESS, label: 'En proceso' },
    { value: Constants.STATUS_NOT_AUCTIONED, label: 'No subastado' },
    { value: Constants.STATUS_DELIVERED, label: 'Entregado' },
    { value: 'facturados', label: 'Facturados' }
];

const allRemitters = { value: null, label: 'Todos los remitentes' };

// El menu se renderiza en el body para que no lo recorte el modal (overlay con z-index 9999)
const selectPortalProps = {
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    styles: { menuPortal: base => ({ ...base, zIndex: 10000 }) }
};

class ModalExportLots extends Component {
    state = {
        remitters: [],
        statusSelect: statusOptions.find(item => item.value === this.props.filterStatus) || statusOptions[0],
        remitterSelect: allRemitters
    }

    componentDidMount = () => {
        toast.configure();
        this.fetchRemitters();
    }

    fetchRemitters = async () => {
        try {
            let response = await customersListAutocomplete({
                token: this.props.sessionProps.account.token,
                auctionRemitters: this.props.auctionId
            });
            await this.setState({
                remitters: response.data.data.customers
            });
        } catch (error) {
            if (error !== undefined && error.response !== undefined && error.response.status === 401) {
                this.props.logout();
            }
            else {
                toast.error(`Ocurrió un error al cargar los remitentes, reintentar`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    pauseOnHover: false,
                    duration: 10000
                });
            }
        }
    }

    close = () => {
        this.props.close();
    }

    download = () => {
        this.props.download({
            filterStatus: this.state.statusSelect.value,
            filterRemitter: this.state.remitterSelect.value
        });
    }

    render() {
        return (
            <div className="container-modal">
                <div className="content-modal">
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <div className="row">
                                            <div className="col-10">
                                                <h5 style={{ marginBottom: 0 }}>Descargar excel de lotes</h5>
                                            </div>
                                            <div className="col-2" onClick={() => this.close()} style={{ textAlign: 'right', cursor: 'pointer' }}>
                                                <h5 style={{ marginBottom: 0 }}>X</h5>
                                            </div>
                                        </div>
                                        <hr style={{ marginTop: '0.5rem' }} />
                                        <FormGroup row>
                                            <Label className="col-md-2 col-form-label">Estado</Label>
                                            <Col md={10} style={{ zIndex: 10 }}>
                                                <Select
                                                    className="select2 select2-multiple"
                                                    {...selectPortalProps}
                                                    options={statusOptions}
                                                    value={this.state.statusSelect}
                                                    onChange={(e) => this.setState({ statusSelect: e })}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label className="col-md-2 col-form-label">Remitente</Label>
                                            <Col md={10} style={{ zIndex: 9 }}>
                                                <Select
                                                    className="select2 select2-multiple"
                                                    {...selectPortalProps}
                                                    options={[
                                                        allRemitters,
                                                        ...this.state.remitters.map(item => ({ value: item.id, label: `${item.id} - ${item.name}` }))
                                                    ]}
                                                    value={this.state.remitterSelect}
                                                    onChange={(e) => this.setState({ remitterSelect: e })}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup className="mb-0 text-right" style={{ marginTop: '1rem' }}>
                                            <div>
                                                <Button onClick={() => this.close()} type="reset" color="secondary">
                                                    Cerrar
                                                </Button>
                                                <Button onClick={() => this.download()} color="success" className="ml-2">
                                                    <i className="mdi mdi-file-excel"></i> Descargar
                                                </Button>
                                            </div>
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    sessionProps: state.userReducer
});

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logoutAction());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalExportLots);
